/**
 * Helper to format large numbers compactly (e.g., 1100 -> $1.1K, 1230 -> $1.23K, 1000000 -> $1M)
 */
export const formatCompactValue = (val) => {
  if (val == null || isNaN(val)) return "";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 2, // Keeps up to 2 decimals without forcing trailing zeroes
  }).format(val);
};
